/**
 * Curated chip suggestions for product attributes. Canonical English terms —
 * free-form entry accepts any language (the LLM reads both). Keep in sync
 * with the backend classification sets in
 * backend/app/services/product_attributes.py.
 */
export const ALLERGEN_SUGGESTIONS = [
  'peanuts', 'tree nuts', 'dairy', 'eggs', 'gluten', 'wheat', 'soy',
  'sesame', 'shellfish', 'fish',
] as const

export const DIETARY_SUGGESTIONS = [
  'vegan', 'vegetarian', 'sugar-free', 'gluten-free', 'dairy-free',
  'keto', 'kosher', 'halal',
] as const
